import { useMemo } from "react";
import { useFilterSettingsStore } from "..";
import { CreatedWithin } from "./IFilterSettings";
import ITenantInMarket from "./ITenantInMarket";

export default function (tenantsInMarket: ITenantInMarket[]): ITenantInMarket[] {
    const { filters: { tenantInMarketSettings: tenantInMarketFilters } } = useFilterSettingsStore();

    return useMemo(() => {
        const minCreatedDate = getMinCreatedDate(tenantInMarketFilters.createdWithin);
        return tenantsInMarket.filter(tm =>
            (!minCreatedDate || tm.createdAt >= minCreatedDate) &&
            (tenantInMarketFilters.showInactive || !tm.inactiveReason)
        );
    }, [tenantsInMarket, tenantInMarketFilters.createdWithin, tenantInMarketFilters.showInactive]);
}

const getMinCreatedDate = (createdWithin: CreatedWithin): Date | null => {
    switch (createdWithin) {
        case CreatedWithin.Anytime:
            return null;
        case CreatedWithin.OneMonth:
            return new Date(new Date().setMonth(new Date().getMonth() - 1));
        case CreatedWithin.ThreeMonth:
            return new Date(new Date().setMonth(new Date().getMonth() - 3));
        case CreatedWithin.SixMonth:
            return new Date(new Date().setMonth(new Date().getMonth() - 6));
        case CreatedWithin.TwelveMonth:
            return new Date(new Date().setMonth(new Date().getMonth() - 12));
    }
}